import * as React from "react";

function SvgIcons8MultipleChoice(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M5 5v6h6V5zm8 2v2h14V7zm-8 6v6h6v-6zm2 2h2v2H7zm6 0v2h14v-2zm-8 6v6h6v-6zm8 2v2h14v-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8MultipleChoice);
